"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPSignIn = void 0;
const lib_pages_1 = __importDefault(require("@opsbase/lib-pages"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AppPageSmall_1 = __importDefault(require("../../AppPage/AppPageSmall"));
const EnterOTP_1 = __importDefault(require("./EnterOTP"));
const SignInWithEmail_1 = __importDefault(require("./SignInWithEmail"));
const SignInWithPhone_1 = __importDefault(require("./SignInWithPhone"));
const SignInWithTeamboard_1 = __importDefault(require("./SignInWithTeamboard"));
function OTPSignIn() {
    return (react_1.default.createElement(AppPageSmall_1.default, null,
        react_1.default.createElement(react_router_dom_1.Switch, null,
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: lib_pages_1.default.AUTH_SIGNIN_ENTEROTP, render: () => react_1.default.createElement(EnterOTP_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: lib_pages_1.default.AUTH_SIGNIN_TEAMBOARD, render: () => react_1.default.createElement(SignInWithTeamboard_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: lib_pages_1.default.AUTH_SIGNIN_PHONE, render: () => react_1.default.createElement(SignInWithPhone_1.default, null) }),
            react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: `*`, render: () => react_1.default.createElement(SignInWithEmail_1.default, null) }))));
}
exports.OTPSignIn = OTPSignIn;
exports.default = OTPSignIn;
